import { expandRoleAliases, normalizeRoleKey } from "@/Utile/roleHelpers.mjs";

// Rolurile care au acces la ruta `/users/:id/roles` (vezi `src/router/index.js`).
// Butonul „Vezi rolurile" din `Datele mele` trebuie să apară doar pentru ele,
// altfel userul ajunge într-un redirect de unauthorized.
export const USER_ROLES_PAGE_ROLE_KEYS = Object.freeze([
  "admin",
  "miniadmin",
  "useradmin-default",
]);

// Cheile de rol sunt grupate în „familii de modul" ca fiecare chip să poarte
// culoarea tonală a modulului din care face parte (vezi tokenii din design.md).
export const roleFamily = (roleKey) => {
  const key = String(roleKey || "").toLowerCase();
  if (key.includes("admin")) return "admin";
  if (key.startsWith("vacation")) return "vacation";
  if (key.startsWith("crm")) return "crm";
  if (key.startsWith("ai")) return "ai";
  if (key === "miridar" || key.includes("core")) return "core";
  return "neutral";
};

// Aceeași rezolvare ca în guard-ul de router: cheile brute plus aliasurile lor
// (`useradmin-*` -> `admin`), ca butonul să nu promită o pagină inaccesibilă.
export const canOpenUserRolesPage = (roleKeys = [], primaryRole = null) => {
  const resolved = new Set();
  [...(Array.isArray(roleKeys) ? roleKeys : []), primaryRole].forEach((entry) => {
    const normalized = normalizeRoleKey(entry);
    if (!normalized) return;
    resolved.add(normalized);
    expandRoleAliases(normalized).forEach((alias) => resolved.add(alias));
  });
  return USER_ROLES_PAGE_ROLE_KEYS.some((role) => resolved.has(role));
};
